
import $ from 'jquery';

/*
* Get fresh form token from Backend and update it to page forms
*/
async function updateTokenToForms(tokenInputs) {
  try {
    const tokenData = await getToken();
    tokenInputs.val(tokenData.token);
  } catch (error) {
    console.log('token retrieve failed.')
  }
}


/**
 * Get token from backend
 * @async
 * @return {jQuery.Promise} resolved after successful request
 */
async function getToken() {
  return $.ajax({
    url: '/stage-ajax/get-token',
    type: 'get'
  });
}

function init() {
  const tokenInputs = $('input[name="stage_token"]');
  if( tokenInputs.length > 0) {
    updateTokenToForms(tokenInputs);
  }
}

export default { init };
export { init };
